<template>
  <div>
    <AppToolbar
      title="Apps"
      @icon-click="toggleDrawer"
    />
    <AppSidebar
      @toggleDrawer="toggleDrawer"
      :drawerProp="drawer"
      :menuItems="navigations"
      :user="userAccountInformation"
    />
    <v-content>
      <router-view userRole="manager"></router-view>
    </v-content>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      drawer: true,
      navigations: [
        {
          title: "Apps",
          icon: "apps",
          path: "/"
        }
      ]
    };
  },
  computed: {
    ...mapState('auth', ['userAccountInformation'])
  },
  methods: {
    toggleDrawer(value) {
      if(value === undefined) {
        this.drawer = !this.drawer;
      } else {
        this.drawer = value
      }
    }
  },
  created() {
  }
};
</script>
